import React from 'react'
import { connect } from 'react-redux'
import {
  // Link,
  withRouter
} from 'react-router-dom'

import {
  // Arrow,
  CallContainer,
  IconColorCian,
  // IconColorDarkBlue,
  Container,
  IconDownload,
  // LinkCancelPlan,
  // Text,
  Title,
  DownloadItem
} from './styles'

import {
  // cancelPlan,
  // cancelAccount,
  downloadTerm,
  downloadGuide,
  downloadPrivacy
} from './data.json'

const CallDownloadTerms = ({ match, accountId, planId, accountPlans, terms, ...props }) => {
  // const plans = accountPlans.plans || []
  // const hasMultiplePlans = plans.length > 1
  // const cancelLink = hasMultiplePlans ? `/minha-veloe/${planId}/cancelar-plano` : '/cancelar-conta'
  console.log({ terms })
  const term = terms && terms.termo && terms.termo.length > 1 ? terms.termo[0] : terms.termo
  return (
    <CallContainer>
      <Container>
        <DownloadItem>
          <IconDownload
            svgStyle={IconColorCian}
            icon="download"
            height="40px"
            width="40px"
            viewBox="0 0 70 70"
            onClick={() => window.open(term.url)}
          />
          <Title onClick={() => window.open(term.url)}>{downloadTerm}</Title>
        </DownloadItem>
        <DownloadItem>
          <IconDownload
            svgStyle={IconColorCian}
            icon="download"
            height="40px"
            width="40px"
            viewBox="0 0 70 70"
            onClick={() => window.open(term.url)}
          />
          <Title style={{ marginTop: 0 }} onClick={() => window.open(terms.manualUsuario.url)}>
            {downloadGuide}
          </Title>
        </DownloadItem>
        <DownloadItem>
          <IconDownload
            svgStyle={IconColorCian}
            icon="download"
            height="40px"
            width="40px"
            viewBox="0 0 70 70"
            onClick={() => window.open(terms.termo.url)}
          />
          <Title style={{ marginTop: 0 }} onClick={() => window.open(terms.termoPrivacidade.url)}>
            {downloadPrivacy}
          </Title>
        </DownloadItem>
      </Container>

      {/* <LinkCancelPlan align="center">
        <Text to={cancelLink}>{hasMultiplePlans ? cancelPlan : cancelAccount}</Text>
        <Link to={cancelLink}>
          <Arrow
            svgStyle={IconColorDarkBlue}
            icon="right-arrow"
            height="16px"
            width="16px"
            viewBox="0 -1 14 14"
          />
        </Link>
      </LinkCancelPlan> */}
    </CallContainer>
  )
}

export const mapStateToProps = ({ reducer }) => ({
  accountPlans: reducer.accountPlans,
  terms: reducer.termsCondition,
  userGuideLink: reducer.userGuideLink
})

export default connect(mapStateToProps)(withRouter(CallDownloadTerms))



// WEBPACK FOOTER //
// ./src/app/modules/CallDownloadTerms/index.js